var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNpOption3079768Ffffff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m31.25 50c0 6.9023-5.5977 12.5-12.5 12.5s-12.5-5.5977-12.5-12.5 5.5977-12.5 12.5-12.5 12.5 5.5977 12.5 12.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m62.5 50c0 6.9023-5.5977 12.5-12.5 12.5s-12.5-5.5977-12.5-12.5 5.5977-12.5 12.5-12.5 12.5 5.5977 12.5 12.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.75 50c0 6.9023-5.5977 12.5-12.5 12.5s-12.5-5.5977-12.5-12.5 5.5977-12.5 12.5-12.5 12.5 5.5977 12.5 12.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpOption3079768Ffffff);
export default __webpack_public_path__ + "static/media/np_option_3079768_FFFFFF.ee35fad99e6d063617a33abc01759871.svg";
export { ForwardRef as ReactComponent };